import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  PageIcon,
  PageDescription,
  ContentGrid,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  TabContainer,
  TabList,
  Tab,
  TabContent,
  fadeIn
} from '../styles/PageStyles';
import { useNavigate } from 'react-router-dom';
import { getAllConnectorsByFilter } from '../services/connectorService';

const Connector = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [connectors, setConnectors] = useState([]);
  
    useEffect(() => {
      const fetchConnectorData = async () => {
        const filters = {};
        const sort = {};
        try {
          const response = await getAllConnectorsByFilter(filters, sort);
          setConnectors(response);
        } catch (error) {
          console.error('Error fetching Connector data:', error);
          navigate('/login'); // Redirect to login if unauthorized
        }
      };
  
      fetchConnectorData();
    }, [navigate]);
    const handleViewConnector = (connectorId) => {
      navigate(`/connector-details/${connectorId}`);
    };
  // Filter connectors based on search term
  const filteredConnectors = connectors.filter(connector => 
    connector.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    connector.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    connector.provider.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeader>
          <PageTitle><PageIcon>⌾</PageIcon> Connector</PageTitle>
          <Button primary onClick={(e)=>{
            handleViewConnector(`connector-details/new`)
          }}>Add New Connector</Button>
        </PageHeader>
        
        <PageDescription>
          Central repository for managing and monitoring all AI connectors used within the application.
          Deploy, version, and track performance metrics for language connectors, computer vision connectors, and specialized ML connectors.
        </PageDescription>
        <ActionBar>
              <SearchInput 
                type="text" 
                placeholder="Search connectors..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {/* <Button>Filter</Button>
              <Button>Sort</Button> */}
            </ActionBar>
            
            <Card>
              <Table>
                <thead>
                  <tr>
                    <TableHeader>Name</TableHeader>
                    <TableHeader style={{width:'15%'}}>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {filteredConnectors.map(connector => (
                    <TableRow key={connector.id}>
                      <TableCell>{connector.name}</TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <Button  onClick={(e)=>handleViewConnector(connector.code)}
                           style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Details</Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </Table>
            </Card>
      </motion.div>
    </PageContainer>
  );
};

export default Connector;
